export const routes = {
  SURVEY: `/survey`,
};

export const partnerCode = {
  SAFECO: 'lm',
  JLR: 'jlr',
};
